export type OrderItemAction =
  | { type: 'SET_IS_INVALID_ORDER_ITEM' }
  | { type: 'SET_IS_FETCHING_PERFORMANCE' }
  | { type: 'SET_FETCH_PERFORMANCE_FAILED' }
  | { type: 'CLEAR_ORDER_ITEM' }
  | { type: 'SET_ORDER_ITEM_ID', id: any }
  | { type: 'SET_PERFORMANCE', performance: Julius.Website.PerformanceOverviewViewModel };

export const setIsInvalidOrderItem = (): OrderItemAction => ({
  type: 'SET_IS_INVALID_ORDER_ITEM',
});

export const setIsFetching = (): OrderItemAction => ({
  type: 'SET_IS_FETCHING_PERFORMANCE',
});

export const setFetchFailed = (): OrderItemAction => ({
  type: 'SET_FETCH_PERFORMANCE_FAILED',
});

export const setPerformance = (performance: Julius.Website.PerformanceOverviewViewModel): OrderItemAction => ({
  performance,
  type: 'SET_PERFORMANCE',
});

export const setOrderItemID = (id: any) => ({
  id,
  type: 'SET_ORDER_ITEM_ID',
})

export const clearOrderItem = (): OrderItemAction => ({
  type: 'CLEAR_ORDER_ITEM',
});


// WEBPACK FOOTER //
// ./src/components/OrderItem/Redux/actions.tsx